import { qwanyxCollection } from 'qwanyx'

/**
 * Fetches a single qwanta by its unique _id
 * 
 * @param {string|ObjectId} id - The unique _id of the qwanta to retrieve
 * @returns {Promise<Object|null>} - The qwanta object if found, null otherwise
 */
export async function getQwanta(id) {
    try {
        const collection = qwanyxCollection();

        // Query by _id to get a single record
        // No projection specified so we get all properties
        const qwanta = await collection.findOne({ _id: id });
            
        return qwanta;
    } catch (error) {
        console.error("Error fetching qwanta:", error);
        throw error;
    }
}